import React from 'react'
import './Copyrightpolicy.css'

const Copyrightpolicy = () => {
    return (
   <div>
            <div id="heading">
                <h3>Copyright Policy</h3>
            </div>
            <div class="conntent-conntainer">
                    <p> Material featured on this site may be reproduced free of charge in any format or media without requiring
                        specific permission.</p>
                    <p> This is subject to the material being reproduced accurately and not being used in a derogatory manner or in
                        a misleading context.</p>
                    <p> Where the material is being published or issued to others, the source must be prominently acknowledged.</p>
                    
                    <p>However, the permission to reproduce this material does not extend to any material on this site, which is
                        explicitly identified as being the copyright of a third party.</p>
                    <p>Authorization to reproduce such material must be obtained from the copyright holders concerned.</p><br/>

                    <h4>Terms & Conditions</h4><br />
                    <p>This website is designed, developed and hosted by Webline. </p>
                    <p>Contents on this website is published, managed, and maintained by NIGST.</p>
                    <p>Though all efforts have been made to ensure the accuracy and currency of the content on this website, the
                        same should not be construed as a statement of law or used for any legal purposes.</p>
                    <p>In case of any ambiguity or doubts, users are advised to verify / check with the Department(s) and / or other
                        source(s), and to obtain appropriate professional advice.</p>
                    <p>Under no circumstances will this Institute be liable for any expense, loss or damage including, without
                        limitation, indirect or consequential loss or damage, or any expense, loss or damage whatsoever arising from
                        use, or loss of use, of data, arising out of or in connection with the use of this website.</p>
                    <p>These terms and conditions shall be governed by and constructed in accordance with the Indian Laws.</p>
                    <p>Any dispute arising under these terms and conditions shall be subject to the jurisdiction of the courts of
                        India.</p>
                    <p>The information posted on this website could include hypertext links or pointers to information created and
                        maintained by non-Government / private organizations.</p>
                    <p>NIGST is providing these links and pointers solely for your information and convenience.</p>
                    <p>When you select a link to an outside website, you are leaving the NIGST website and are subject to the
                        privacy and security policies of the owners/sponsors of the outside website.</p>
                    <p> Survey of India does not guarantee the availability of such linked pages at all times.</p><br/>


                    <h4>Disclaimer</h4><br />
                    <p>Welcome to the renewed website of NIGST</p>

                    <p>On this website you shall find latest information about various activities and Maps etc published by the
                        NIGST.</p>

                    <p>NIGST shall not be liable for any loss or damage whatsoever, including incidental or consequential loss or
                        damage, arising out of, or in connection with, any use of or reliance on the information from this website.
                    </p><br />
                    <p>In case of any suggestion, clarification of doubt or query, users are requested to refer to the original
                        documents by contacting the issuing authority.</p>

                </div>
            </div>
     
      

    )
}

export default Copyrightpolicy
